import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ERROR_TRANSLATOR } from '@x/common/error';
import { IconModule } from '@x/common/icon';
import { OperationModule } from '@x/common/operation';
import { ShopClientErrorTranslator } from '@x/ecommerce-shop/app/core/shop-error/error-translations/shop-client.error-translator';
import { ShopErrorOperationComponent } from '@x/ecommerce-shop/app/core/shop-error/shop-error-operation/shop-error-operation.component';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';

@NgModule({
  declarations: [ShopErrorOperationComponent],
  imports: [
    CommonModule,
    CdkConnectedOverlay,
    MatButtonModule,
    NeedHelpModule,
    OperationModule,
    UtilsModule,
    IconModule,
    IconUiModule,
    MatTooltipModule,
  ],
  exports: [ShopErrorOperationComponent],
})
export class ShopErrorModule {
  static forRoot(): ModuleWithProviders<ShopErrorModule> {
    return {
      ngModule: ShopErrorModule,
      providers: [
        {
          provide: ERROR_TRANSLATOR,
          useClass: ShopClientErrorTranslator,
          multi: true,
        },
      ],
    };
  }
}
